var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","d-flex":"","justify-center":""}},[_c('HomePageMap')],1),_c('div',{staticClass:"mt-4"},[_c('p',{staticClass:"disclaimer-text",domProps:{"innerHTML":_vm._s(_vm.DISCLAIMER_TEXT)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }